import React from 'react';
import { Phone } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ec80005d-fba4-4969-be74-853cc224eb78/artifacts/7f8it9m3_spanski-law-logo.webp';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-[#050505] py-16">
      {/* Top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a87c]/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Spanski Law PLLC - Florida Lady Bird Deed Attorney Logo" 
              className="h-12 w-auto mb-6"
            />
            <p className="font-sans text-[#faf9f7]/60 max-w-md leading-relaxed mb-4">
              Spanski Law, PLLC provides expert legal guidance for Florida homeowners seeking to protect 
              their property and legacy through Lady Bird Deeds and comprehensive estate planning.
            </p>
            <a 
              href="tel:941-206-2223" 
              className="inline-flex items-center gap-2 font-sans text-[#c9a87c] hover:text-[#d4b896] transition-colors mb-4"
            >
              <Phone className="w-4 h-4" />
              (941) 206-2223
            </a>
            <p className="font-serif text-lg text-[#c9a87c]/80 italic">
              "Protecting what matters most."
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-sans text-sm tracking-widest uppercase text-[#c9a87c] mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Benefits', href: '#benefits' },
                { name: 'How It Works', href: '#how-it-works' },
                { name: 'About', href: '#about' },
                { name: 'FAQ', href: '#faq' },
                { name: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="font-sans text-[#faf9f7]/60 hover:text-[#c9a87c] transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-sans text-sm tracking-widest uppercase text-[#c9a87c] mb-6">Services</h4>
            <ul className="space-y-3">
              {[
                'Lady Bird Deeds',
                'Estate Planning',
                'Property Transfer',
                'Probate Avoidance',
                'Homestead Protection',
              ].map((service) => (
                <li key={service}>
                  <span className="font-sans text-[#faf9f7]/60">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#c9a87c]/20 to-transparent mb-8" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
            <p className="font-sans text-sm text-[#faf9f7]/40">
              © {currentYear} Spanski Law, PLLC. All rights reserved.
            </p>
            <span className="hidden md:inline text-[#faf9f7]/20">|</span>
            <p className="font-sans text-sm text-[#faf9f7]/40">
              thelawyerlady.com
            </p>
          </div>

          {/* Legal disclaimer */}
          <p className="font-sans text-xs text-[#faf9f7]/30 text-center md:text-right max-w-lg">
            This website is for informational purposes only and does not constitute legal advice. 
            Attorney-client relationship is established only through formal engagement.
          </p>
        </div>

        {/* Florida Bar Notice */}
        <div className="mt-8 text-center">
          <p className="font-sans text-xs text-[#faf9f7]/25">
            Season A. Spanski is licensed to practice law in the State of Florida.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
